const SkipToContent = () => (
  <a
    href="#main-content"
    className="sr-only"
  >
    Skip to main content
  </a>
);

export default SkipToContent;
